import { render, staticRenderFns } from "./OrcamentoObservacoes.vue?vue&type=template&id=fc65f1b0&scoped=true"
import script from "./OrcamentoObservacoes.vue?vue&type=script&lang=js"
export * from "./OrcamentoObservacoes.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoObservacoes.vue?vue&type=style&index=0&id=fc65f1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc65f1b0",
  null
  
)

export default component.exports